export const fields = [
    { key: 'index', label: "No", _style:'min-width:30px'},
    { key: 'select', label: "", _style:'min-width:30px' },
    { key: 'qr_code', label: "", _style:'min-width:100px' },
    { key: 'name', label: "Nama", _style:'min-width:100px' },
    { key: 'city', label: "Asal Kota", _style:'min-width:100px' },
    { key: 'institution', label: "Asal Instansi", _style:'min-width:100px' },
    { key: 'table_number', label: "Nomor Meja", _style:'min-width:100px' },
    { key: 'is_checked_in', label: "Checked In", _style:'min-width:100px' },
    { key: 'created_at', label: "Tanggal Dibuat", _style:'min-width:100px' },
    { key: 'updated_at', label: "Tanggal Diubah", _style:'min-width:100px' },
    { key: "action", label: 'Aksi', _style: 'min-width:75px'}
]